import {atomWithStorage} from "jotai/utils";

const LOCAL_STORAGE_ADMIN_COMPANIES_TABLE_COLUMNS_VISIBILITY_KEY = "adminCompaniesTableColumnsVisibility";
const LOCAL_STORAGE_ADMIN_COMPANIES_TABLE_COLUMNS_SIZE_KEY = "adminCompaniesTableColumnsSize";

const DEFAULT_ADMIN_COMPANIES_TABLE_COLUMN_VISIBILITY: Record<string, boolean> = {
    name: true,
    id: true,
    address: true,
    phone: true,
    vat: true,
    invoiceEmail: true,
    isReseller: true,
    isApiEnabled: true,
    createdAt: true,
    updatedAt: false,
};

export const adminCompaniesTableColumnsVisibilityAtom = atomWithStorage<Record<string, boolean>>(
    LOCAL_STORAGE_ADMIN_COMPANIES_TABLE_COLUMNS_VISIBILITY_KEY,
    DEFAULT_ADMIN_COMPANIES_TABLE_COLUMN_VISIBILITY,
);

export const adminCompaniesTableColumnsSizeAtom = atomWithStorage<Record<string, number> | undefined>(
    LOCAL_STORAGE_ADMIN_COMPANIES_TABLE_COLUMNS_SIZE_KEY,
    undefined,
);
